<template>
	<div style="background: #f5f5f5">
		<div class="btnBox">
			<div class="btnItem supHove3" @click="xyBtn(2)">用户协议</div>
			<div class="btnItem supHove3" @click="xyBtn(3)">隐私政策</div>
			<div class="btnItem supHove3" @click="fkBtn">帮助反馈</div>
			<div class="btnItem supHove3" @click="dlBtn">登录平台</div>
			<div class="btnItem supHove3" @click="xyBtn(4)">关于平台</div>
			<div class="btnItem supHove3" @click="xyBtn(5)">联系我们</div>
		</div>
		<p>
			© 2014-2020｜ {{ appCompany.configValue }} ｜
			<i @click="baBtn" class="supHove3">
				{{ icpData?.configValue }}
			</i>
			｜
			<img src="@/assets/img/ga.png" alt="" />
			<i @click="gaBtn(gaData.configValue)" class="supHove3">{{ gaData?.configValue }}</i>
		</p>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	name: 'loginFoot',
	data() {
		return {};
	},
	computed: {
		...mapState(['icpData', 'gaData', 'appCompany'])
	},
	methods: {
		baBtn() {
			window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank');
		},
		gaBtn(val) {
			let num = val.match(/\d+/g)[0];
			window.open(`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${num}`);
		},
		xyBtn(type) {
			this.$router.push({
				path: 'userAgreen',
				query: {
					type: type
				}
			});
		},
		fkBtn() {
			let token = localStorage.getItem('token');
			if (!token) {
				this.$message({
					message: '请在登录后反馈意见哦~',
					type: 'warning'
				});
				return;
			}
			this.$router.push({
				path: 'feedback'
			});
		},
		dlBtn() {
			this.$router.push({
				path: 'login'
			});
		}
	},
	mounted() {
		console.log(this.icpData, 9998888);
	}
};
</script>
<style lang="scss" scoped>
.btnBox {
	color: #999a9c;
	display: flex;
	justify-content: center;
	font-size: 12px;
	padding: 13px 0 60px;
	.btnItem {
		padding: 0 14px;
		cursor: pointer;
	}
}
p {
	font-size: 12px;
	color: #999a9c;
	padding-bottom: 23px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	img {
		margin-right: 2px;
	}
}
</style>
